import {BACKEND_API} from '../middleware/backend'
import {Date} from "../components/utils";

export const SEASONS_REQUEST = 'SEASONS_REQUEST';
export const SEASONS_SUCCESS = 'SEASONS_SUCCESS';
export const SEASONS_FAILURE = 'SEASONS_FAILURE';

export const RACES_REQUEST = 'RACES_REQUEST';
export const RACES_SUCCESS = 'RACES_SUCCESS';
export const RACES_FAILURE = 'RACES_FAILURE';

export const RACE_REQUEST = 'RACE_REQUEST';
export const RACE_SUCCESS = 'RACE_SUCCESS';
export const RACE_FAILURE = 'RACE_FAILURE';

export const RACE_RESULT_REQUEST = 'RACE_RESULT_REQUEST';
export const RACE_RESULT_SUCCESS = 'RACE_RESULT_SUCCESS';
export const RACE_RESULT_FAILURE = 'RACE_RESULT_FAILURE';

export const RACE_RESULT_INTER_REQUEST = 'RACE_RESULT_INTER_REQUEST';
export const RACE_RESULT_INTER_SUCCESS = 'RACE_RESULT_INTER_SUCCESS';
export const RACE_RESULT_INTER_FAILURE = 'RACE_RESULT_INTER_FAILURE';


export const loadSeasons = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SEASONS_REQUEST, SEASONS_SUCCESS, SEASONS_FAILURE],
			endpoint: "seasons",
			filter: filter
		}
	})
};

export const loadRaces = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [RACES_REQUEST, RACES_SUCCESS, RACES_FAILURE],
			endpoint: `${filter.seasonId}/races`,
			filter: filter
		}
	})
};

export const loadRace = (filter) => (dispatch, getState) => {
	return dispatch({
		id: `${filter.seasonId}-${filter.eventId}-${filter.raceId}`,
		[BACKEND_API]: {
			types: [RACE_REQUEST, RACE_SUCCESS, RACE_FAILURE],
			endpoint: `${filter.seasonId}/${filter.eventId}/${filter.raceId}`,
			filter: filter
		}
	})
};

export const loadRaceResults = (filter) => (dispatch, getState) => {
	return dispatch({
		id: `${filter.seasonId}-${filter.eventId}-${filter.raceId}-${filter.compGroupId}`,
		[BACKEND_API]: {
			types: [RACE_RESULT_REQUEST, RACE_RESULT_SUCCESS, RACE_RESULT_FAILURE],
			endpoint: `${filter.seasonId}/${filter.eventId}/${filter.raceId}/${filter.compGroupId}`,
			filter: filter
		}
	})
};

export const dispatchRaceResultsRequest = (filter) => (dispatch) => {
	return dispatch({
		type: RACE_RESULT_REQUEST,
		id: `${filter.seasonId}-${filter.eventId}-${filter.raceId}-${filter.compGroupId}`,
	})
};

export const dispatchRaceResults = (data) => (dispatch, getState) => {
	Object.assign(data, {ts: Date.currentTS()});
	return dispatch({
		type: RACE_RESULT_SUCCESS,
		id: data.id,
		response: {data}
	})
};

export const loadRaceResultIntermediates = (filter) => (dispatch, getState) => {
	return dispatch({
		id: `${filter.seasonId}-${filter.eventId}-${filter.raceId}-${filter.compGroupId}`,
		[BACKEND_API]: {
			types: [RACE_RESULT_INTER_REQUEST, RACE_RESULT_INTER_SUCCESS, RACE_RESULT_INTER_FAILURE],
			endpoint: `${filter.seasonId}/${filter.eventId}/${filter.raceId}/${filter.compGroupId}/inter`,
			filter: filter
		}
	})
};

export const dispatchRaceResultIntermediatesRequest = (filter) => (dispatch) => {
	return dispatch({
		type: RACE_RESULT_INTER_REQUEST,
		id: `${filter.seasonId}-${filter.eventId}-${filter.raceId}-${filter.compGroupId}`,
	})
};

export const dispatchRaceResultIntermediates = (data) => (dispatch, getState) => {
	Object.assign(data, {ts: Date.currentTS()});
	return dispatch({
		type: RACE_RESULT_INTER_SUCCESS,
		id: data.id,
		response: {data}
	})
};



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/actions/online.js